//breakpoints copied from Layout.css
export const BREAKPOINTS_PX = {
  mobile: 411,
  tablet: 768,
  laptop: 1366,
  laptopLarge: 1680,
  desktop: 1920
};

const BASE_FONT_SIZE = 16;
const rem = (size, context = BASE_FONT_SIZE) => `${size / context}rem`;

export const BREAKPOINTS = {
  mobile: rem(BREAKPOINTS_PX.mobile),
  tablet: rem(BREAKPOINTS_PX.tablet),
  laptop: rem(BREAKPOINTS_PX.laptop),
  laptopLarge: rem(BREAKPOINTS_PX.laptopLarge),
  desktop: rem(BREAKPOINTS_PX.DESKTOP)
};
